import React from "react";
import { Route } from "react-router-dom";
import HrGate from "./HrGate";
import HrOverview from "./HrOverview";
import MySpace from "./MySpace";
import Approvals from "./Approvals";
import Leave from "./Leave";
import Employees from "./Employees";
import EmployeeProfile from "./EmployeeProfile";
import OrgChart from "./OrgChart";
import Documents from "./Documents";
import HrSettings from "./HrSettings";
import Roster from "./Roster";
import Attendance from "./Attendance";
import Payroll from "./payroll/Payroll";
import PayrollRunDetail from "./payroll/PayrollRunDetail";
import MyPayslips from "./payroll/MyPayslips";
import TeamMemberProfile from "./TeamMemberProfile";

// The HR route tree. A fragment of <Route>s (not a component) so it can sit inside <Routes> in App.js.
// Everything is behind HrGate (HR must be on for the vendor); overview and settings also need a permission set.
export const hrRoutes = (
  <>
    <Route element={<HrGate />}>
      <Route path="/hr/my" element={<MySpace />} />
      <Route path="/hr/me" element={<EmployeeProfile mine />} />
      <Route path="/hr/approvals" element={<Approvals />} />
      <Route path="/hr/leave" element={<Leave />} />
      <Route path="/hr/roster" element={<Roster />} />
      <Route path="/hr/attendance" element={<Attendance />} />
      <Route path="/hr/employees" element={<Employees />} />
      <Route path="/hr/employees/:id" element={<EmployeeProfile />} />
      <Route path="/hr/documents" element={<Documents />} />
      <Route path="/hr/org-chart" element={<OrgChart />} />
    </Route>
    {/* The Employees capability every plan has: the list, add / edit, ending employment. */}
    <Route element={<HrGate employees />}>
      <Route path="/hr/team" element={<Employees />} />
      <Route path="/hr/team/:id" element={<TeamMemberProfile />} />
    </Route>
    <Route element={<HrGate feature="PAYROLL" />}>
      <Route path="/hr/payslips" element={<MyPayslips />} />
    </Route>
    <Route element={<HrGate feature="PAYROLL" permission={["PAYROLL_ADMIN", "FINANCE_APPROVER"]} />}>
      <Route path="/hr/payroll" element={<Payroll />} />
      <Route path="/hr/payroll/runs/:id" element={<PayrollRunDetail />} />
    </Route>
    {/* Matches the sidebar's own "isHr" check (HR_ADMIN or HR_VIEWER) - an HR admin without a separate HR_VIEWER
        grant must not see this link and then be blocked by it. */}
    <Route element={<HrGate permission={["HR_ADMIN", "HR_VIEWER"]} landing />}>
      <Route path="/hr" element={<HrOverview />} />
    </Route>
    <Route element={<HrGate permission="HR_ADMIN" />}>
      <Route path="/hr/settings" element={<HrSettings />} />
    </Route>
  </>
);

export default hrRoutes;
